import React from 'react';
import { InputMask } from '@react-input/mask';
import { MaskedInputProps } from './types';
import BaseInput from '@src/components/reusable/input/BaseInput';

const MaskedInput: React.FC<MaskedInputProps> = ({
  mask,
  replacement,
  separate = false,
  showMask = false,
  ...rest
}) => {
  return (
    <InputMask
      mask={mask}
      replacement={replacement}
      separate={separate}
      showMask={showMask}
      {...rest}
      component={BaseInput}
    />
  );
};

export default MaskedInput;
